import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SignInButton, SignOutButton, } from '@zurich-framework/nextapp/components';
import { useTranslation } from '@zurich/common/hooks';
import { Container, Typography } from '@zurich/ui/legacy/components';
import { styled } from '@zurich/ui/legacy/utils';
import { InfoCard } from '../';
const ButtonContainer = styled('div')(() => ({
    textAlign: 'right',
}));
export function SignOut({ result = 'success' }) {
    const { t } = useTranslation();
    return (_jsx(Container, { spacing: 5, children: _jsx(InfoCard, { title: _jsx(Typography, { variant: "h4", children: t(`portal:signout.title.${result}`) }), description: _jsxs("div", { children: [_jsx("p", { children: t(`portal:signout.description.${result}`, '') }), _jsx(ButtonContainer, { children: result === 'error' ? (_jsx(SignOutButton, { label: t('portal:signout.signoutButtonLabel') })) : (_jsx(SignInButton, { label: t('portal:signout.signinButtonLabel') })) })] }) }) }));
}
